export default () => {
  const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
  let smoothScrollType;

  const smoothScroll = (e, i, gap) => {
    e.preventDefault();
    const offset = document.documentElement.scrollTop || document.body.scrollTop;
    let href = smoothScrollTrigger[i].getAttribute('href');
    let targetElement = document.getElementById(href.replace('#', ''));
    const rect = targetElement.getBoundingClientRect().top;
    const target = rect + offset - gap;
    window.scrollTo({
      top: target, behavior: 'smooth',
    });
  };

  /* scrollToのOptionsに対応していない場合 */
  const oldTypeSmoothScroll = (e, i, gap) => {
    e.preventDefault();
    const scrollSpeed = 300;
    const timerStep = 20;
    const pageLinkId = e.target.hash;
    const pageLinkSection = document.querySelector(pageLinkId);

    const scrollPosition = window.pageYOffset;
    const sectionPosition = pageLinkSection.getBoundingClientRect().top;
    const goalPosition = scrollPosition + sectionPosition - gap;

    const scrollStep = sectionPosition / (scrollSpeed / timerStep);
    let currentScroll = scrollPosition;

    let smoothScrollTimer = setInterval(() => {
      if (currentScroll >= goalPosition) {
        window.scrollTo(0, goalPosition);
        clearInterval(smoothScrollTimer);
      } else {
        currentScroll += scrollStep;
        window.scrollTo(0, currentScroll);
      }
    }, timerStep);
  };

  if ('scrollBehavior' in document.documentElement.style) {
    smoothScrollType = smoothScroll;
  } else {
    smoothScrollType = oldTypeSmoothScroll;
  }

  for (let i = 0; i < smoothScrollTrigger.length; i++) {
    smoothScrollTrigger[i].addEventListener('click', (e) => {
      const gap = 60;
      smoothScrollType(e, i, gap);
    });
  }
};
